<template>
  <!-- 有綁型錄：點卡片進型錄；標題裡的網址獨立可點（新分頁開啟、不會連帶進型錄）。
       連結不能包連結，所以卡片用 click 事件導頁，網址的 click 加 .stop 擋掉。 -->
  <div @click="goCatalog">
    <p>
      <card no-body
            shadow-size="sm"
            class="border-main-color" :class="{'cursor-pointer': hasCatalog}" style="border-width: 0 0 0 5px">
        <div class="row align-items-center mx-0">
          <div class="pl-5" style="flex: 1; min-width: 0; overflow: hidden;">
            <div class="mt-1"></div>
            <p class="m-0 text-custom-text font-weight-500 news-title"><template v-for="(part, index) in titleParts"><a
                v-if="part.url"
                :key="index"
                :href="part.url"
                target="_blank"
                rel="noopener noreferrer"
                @click.stop
                class="news-link"
            >{{ part.text }}</a><span v-else :key="index">{{ part.text }}</span></template></p>
            <p class="m-0 font-size-11 font-weight-500 text-custom-gray-2">{{ formatDateOnly(item.publish_date) }}</p>
            <div class="mt-1"></div>
          </div>
          <div v-if="hasCatalog" class="pr-5">
            <div>
              <i class="fa fa-angle-right fa-2x text-main-color" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </card>
    </p>
  </div>
</template>
<script>

import {formatDateOnly} from "@/util/formatter";

// 只認 http:// 與 https://，遇到空白或中文／全形標點就結束，避免把後面的中文也吃進網址
const URL_PATTERN = /https?:\/\/[^\s\u3000-\u303f\uff00-\uffef\u4e00-\u9fff]+/gi;
// 句尾的半形標點通常不是網址的一部分（例如「請看 https://a.com/x.」）
const TRAILING_PUNCTUATION = /[.,;:!?)\]'"]+$/;

export default {
  name: "NewsItem",
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    // 把標題切成「純文字」與「網址」片段；網址片段帶 url，文字片段不帶
    titleParts() {
      const title = (this.item && this.item.title) || '';
      const parts = [];
      let last = 0;
      for (const match of title.matchAll(URL_PATTERN)) {
        const raw = match[0];
        const url = raw.replace(TRAILING_PUNCTUATION, '');
        if (match.index > last) parts.push({text: title.slice(last, match.index)});
        parts.push({text: url, url});
        last = match.index + url.length;
      }
      if (last < title.length) parts.push({text: title.slice(last)});
      return parts;
    },
    hasCatalog() {
      return !!(this.item && this.item.catalog_id);
    },
  },
  methods: {
    goCatalog() {
      if (this.hasCatalog) this.$router.push({name: 'commodity', params: {id: this.item.catalog_id}});
    },
    formatDateOnly,
  }
}
</script>

<style scoped>
.news-title {
  white-space: normal;
  word-break: break-word;
}

.news-link {
  color: #F39800;
  text-decoration: underline;
}
</style>
